
export class Region {
    name: string

    constructor(name: any) {
        this.name = name;
    }
}